<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t(title) }} </span>
        </v-card-title>
        <v-divider></v-divider>
        <br />
        <v-card-text>
          <v-container>
            <v-form v-model="valid" ref="form">
              <v-row>
                <v-col v-if="update == true" cols="12" class="ma-0 pa-0">
                  <v-select
                    :items="getEmployee"
                    filled
                    outlined
                    :label="$t('vehicle.newPopup.employee')"
                    dense
                    v-model="data.did"
                    item-text="name"
                    item-value="id"
                    class="ma-0 pa-0"
                  >
                    <template v-slot:item="{ item }">
                      <v-list-item-avatar color="white" contain>
                        <v-avatar size="56">
                          <v-img :src="item.avatar" max-height="50">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular
                                  indeterminate
                                  color="primary"
                                ></v-progress-circular>
                              </v-row> </template
                          ></v-img>
                        </v-avatar>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.name"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12" class="ma-0 pa-0">
                  <v-text-field
                    outlined
                    :disabled="update == true ? true : false"
                    class="ma-1 pa-0"
                    v-model="data.brand"
                    :label="$t('vehicle.newPopup.brand')"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="6" class="ma-0 pa-0">
                  <v-text-field
                    outlined
                    class="ma-1"
                    v-model="data.model"
                    :rules="[rules.required]"
                    :label="$t('vehicle.newPopup.model')"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6" class="ma-0 pa-0">
                  <v-text-field
                    outlined
                    class="ma-1"
                    v-model="data.engineType"
                    :rules="[rules.required]"
                    :label="$t('vehicle.newPopup.engineType')"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                  class="ma-0 pa-0"
                  v-if="update != true"
                >
                </v-col>
                <v-col cols="12" class="ma-0 pa-0">
                  <v-text-field
                    outlined
                    class="ma-1 pa-0"
                    classname="form-control"
                    :rules="[rules.required]"
                    persistent-hint
                    :label="$t('vehicle.newPopup.carId')"
                    v-model="data.carId"
                  >
                  </v-text-field>
                </v-col> </v-row
            ></v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="close">
            {{ $t("btn.cancel") }}
          </v-btn>

          <v-btn
            color="primary"
            :dark="!clicked"
            @click.prevent="submit"
            :disabled="clicked"
            :loading="clicked"
          >
            {{ $t("btn.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  data: () => {
    return {
      valid: true,
      clicked: false,
      rules: {
        required: null,
      },
    };
  },
  created() {
    this.rules.required = (v) => !!v || this.$t("rules.require");
  },
  props: {
    dialog: { type: Boolean, default: () => false },
    data: { type: Object, default: () => {} },
    update: { type: Boolean, default: () => true },
  },

  computed: {
    userMe() {
      return this.$store.getters["users/userMe"];
    },

    ...mapGetters("employees", ["employees"]),
    getEmployee() {
      return this.employees.filter((em) => {
        return em.role == 2;
      });
    },

    title() {
      return this.update == true
        ? "vehicle.newPopup.update"
        : "vehicle.newPopup.title";
    },
  },
  methods: {
    ...mapActions("vehicleStore", ["addOne", "updateOne"]),
    close() {
      if (this.update == false) this.$refs.form.reset();
      this.$emit("close-dialog", false);
    },
    submit() {
      this.$refs.form.validate();
      if (this.valid == false) return;
      this.clicked = true;
      const payload = this.data;
      payload.type = "Truck";
      payload.src_id = 1;
      if (this.update == false) {
        this.addOne(payload)
          .then((res) => {
            this.$refs.form.reset();

            this.$emit("close-dialog", false);
            this.clicked = false;
          })
          .catch((err) => {
            this.clicked = false;
            this.$emit("close-dialog", false);
          });
      } else {
        payload.id = this.data.id;
        this.updateOne(payload)
          .then((res) => {
            this.clicked = false;
            this.$emit("close-dialog", false);
          })
          .catch((err) => {
            this.clicked = false;
            this.$emit("close-dialog", false);
          });
      }
    },
  },
};
</script>
